<div
  class="grid grid-cols-1 gap-4"
  [ngClass]="{
    'lg:grid-cols-2': (chartHistory$ | async)?.length
  }"
>
  <pr-content-container height="h-full" class="flex h-full flex-col">
    <div class="flex h-full flex-col">
      <p class="font-bold">Create a new periodontal chart</p>
      <div class="mt-auto">
        <button
          class="w-full"
          mat-stroked-button
          (click)="createPerioRecords()"
        >
          <mat-icon>add</mat-icon>
          New Periodontal Chart
        </button>
      </div>
    </div>
  </pr-content-container>

  @if (chartHistory$ | async; as history) {
    @if (history.length) {
      <pr-content-container class="flex h-full flex-col">
        <div class="flex h-full flex-col gap-4">
          <p class="font-bold">Copy values from a previous chart</p>
          <div class="flex flex-col gap-4 xl:flex-row">
            <pr-charting-history-selector
              [selected]="selectedChart$ | async"
              [chartHistory]="chartHistory$ | async"
              (selectedChange)="selectedChart$.next($event)"
            />
            <mat-form-field class="w-full" subscriptSizing="dynamic">
              <mat-label>Select Measurements</mat-label>
              <mat-select multiple [formControl]="measurementsCtrl">
                @for (measurement of measurements; track measurement) {
                  <mat-option [value]="measurement">
                    @if (measurement | map: isUppercaseMeasurement) {
                      {{ measurement | uppercase }}
                    } @else {
                      {{ measurement | splitCamel | titlecase }}
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="mt-auto">
            <button
              class="w-full"
              mat-stroked-button
              (click)="copyPerioRecords()"
            >
              <mat-icon>content_copy</mat-icon>
              Copy Previous Chart
            </button>
          </div>
        </div>
      </pr-content-container>
    }
  }
</div>
